import {
  ErrorBoundary,
  JupiterTheme,
  useSnackbarNotification,
} from '@jupiterone/jupiter-web-toolkit';
import { Fade, Grid } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { AccountModalPage } from 'navbar/src/jupiterAccountSettings/types';
import AccountManagementPage from 'navbar/src/jupiterAccountSettings/AccountSettings/AccountManagement/AccountManagementPage';
import ApiKeysPage from 'navbar/src/jupiterAccountSettings/AccountSettings/ApiKeys/ApiKeysPage';
import AuthenticationClientsPage from 'navbar/src/jupiterAccountSettings/AccountSettings/AuthenticationClients/AuthenticationClientsPage';
import InvitationPage from 'navbar/src/jupiterAccountSettings/AccountSettings/Invitation/InvitationPage';
import UserProfilePage from 'navbar/src/jupiterAccountSettings/AccountSettings/UserProfile/UserProfilePage';
import UsersAccessPage from 'navbar/src/jupiterAccountSettings/AccountSettings/UsersAccess/UsersAccessPage';
import useSharedUsersAndAccountStyles from 'navbar/src/jupiterAccountSettings/AccountSettings/useSharedUsersAndAccountStyles';
import NotificationsPage from 'navbar/src/jupiterAccountSettings/AccountSettings/Notifications';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    gridItem: {
      height: '100%',
      display: 'flex',
      flexFlow: 'column',
      overflow: 'hidden',
      background: 'rgba(0,0,0,0.5)',
      borderRadius: '0 4px 4px 0',
      position: 'relative',
      '&:before': {
        background: theme.palette.primary.dark,
        display: 'block',
        content: `''`,
        width: '100%',
        top: 0,
        left: 0,
      },
    },
    outerStyled: {
      overflowY: 'auto',
      padding: theme.spacing(10),
      '&::-webkit-scrollbar': {
        background: `rgba(8, 34, 76, .875)`,
        borderRadius: '0 4px 4px 0',
      },
      '&::-webkit-scrollbar-thumb': {
        background: `rgba(0, 6, 42, .875)`,
        borderRadius: '0 4px 4px 0',
      },
    },
  })
);

interface RightNavProps {
  activePage: AccountModalPage;
}

const RightNav = ({ activePage }: RightNavProps) => {
  const classes = useStyles();
  const sharedClasses = useSharedUsersAndAccountStyles();
  const notification = useSnackbarNotification();

  return (
    <Grid item={true} sm={8} md={8} className={classes.gridItem}>
      <Fade in={true} timeout={500} style={{ transitionDelay: '500' }}>
        {({
          access: (
            <div className={clsx(sharedClasses.centerContent)}>
              <ErrorBoundary>
                <UsersAccessPage />
              </ErrorBoundary>
            </div>
          ),
          apiKeys: (
            <div
              className={clsx(sharedClasses.centerContent, classes.outerStyled)}
            >
              <ErrorBoundary>
                <ApiKeysPage />
              </ErrorBoundary>
            </div>
          ),
          accountManagement: (
            <div
              className={clsx(sharedClasses.centerContent, classes.outerStyled)}
            >
              <ErrorBoundary>
                <AccountManagementPage />
              </ErrorBoundary>
            </div>
          ),
          profile: (
            <div
              className={clsx(sharedClasses.centerContent, classes.outerStyled)}
            >
              <ErrorBoundary>
                <UserProfilePage />
              </ErrorBoundary>
            </div>
          ),
          invitations: (
            <div
              className={clsx(sharedClasses.centerContent, classes.outerStyled)}
            >
              <ErrorBoundary>
                <InvitationPage notification={notification} />
              </ErrorBoundary>
            </div>
          ),
          notifications: (
            <div className={clsx(sharedClasses.centerContent)}>
              <ErrorBoundary>
                <NotificationsPage />
              </ErrorBoundary>
            </div>
          ),
          clients: (
            <div
              className={clsx(sharedClasses.centerContent, classes.outerStyled)}
            >
              <AuthenticationClientsPage />{' '}
            </div>
          ),
        } as any)[activePage] || <div />}
      </Fade>
    </Grid>
  );
};

export default RightNav;
